// src/app/views/pages_user/g7/rtUsG7.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { getPathByCdExt } from "app/utils/utils";
import { EXAM_TYPES } from "app/types/examTypes";

const UsG7List = Loadable(lazy(() => import("./UsG7List")));
const UsG7ExamExam = Loadable(lazy(() => import("./UsG7Exam")));
const ApplicationLogin = Loadable(lazy(() => import("./ApplicationLogin")));
const ApplicationInfo = Loadable(lazy(() => import("./ApplicationInfo")));
const PaymentResult = Loadable(lazy(() => import("./PaymentResult")));
const Login = Loadable(lazy(() => import("./Login")));
const UsG7ExamReview = Loadable(lazy(() => import("./UsG7ExamReview")));
const pathExt = getPathByCdExt(EXAM_TYPES.G7.rid_cd_ext);

const rtUsG7 = [
  { path: `/user/${pathExt}/login`, element: <Login /> },
  { path: `/user/${pathExt}/applogin`, element: <ApplicationLogin /> },
  { path: `/user/${pathExt}/application-info`, element: <ApplicationInfo /> },
  { path: `/user/${pathExt}/payment-result`, element: <PaymentResult /> },
  { path: `/user/${pathExt}/list/:rid_cd_ext/:rid_user`, element: <UsG7List /> },
  { path: `/user/${pathExt}/exam/:rid_cd_ext/:rid_user/:rid_imp`, element: <UsG7ExamExam /> },
  { path: `/user/${pathExt}/exam/review/:rid_cd_ext/:rid_imp/:rid_subj/:rid_user/:num_answer`, element: <UsG7ExamReview /> }
];
export default rtUsG7;
